module.exports = __webpack_public_path__ + "img/lincoln-New.1bfb4755.png";